/**
 * Analytics chart palette & shade matrix — single source of truth.
 *
 * Edit `CHART_COLORS` here: the Foundations → Color page (shade matrix) and the
 * Charts design-system page both consume this module. Re-exported from `ColorsPage`
 * for discoverability alongside the Color docs.
 */
export const CHART_COLORS = {
  green: '#00A76F',
  amber: '#FFAB00',
  cyan: '#00B8D9',
  orange: '#F97316',
  violet: '#8B5CF6',
  teal: '#00B8A3',
  blue: '#3366FF',
  rose: '#FF4081',
} as const;

/** Shade-matrix order: 1st series = green, 2nd = amber, 3rd = cyan, … through rose. */
export const CHART_PALETTE_ORDER = [
  CHART_COLORS.green,
  CHART_COLORS.amber,
  CHART_COLORS.cyan,
  CHART_COLORS.orange,
  CHART_COLORS.violet,
  CHART_COLORS.teal,
  CHART_COLORS.blue,
  CHART_COLORS.rose,
] as const;

/** Deterministic palette color for a label (e.g. assessment type) — stable across renders and pages. */
export function stablePaletteColorForKey(key: string): string {
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = (Math.imul(31, hash) + key.charCodeAt(i)) >>> 0;
  }
  return CHART_PALETTE_ORDER[hash % CHART_PALETTE_ORDER.length];
}
